/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { ReactNode } from 'react';

type HoverableProps = {
  children: (options: { isHovered: boolean }) => ReactNode;
  className?: string;
  describedById?: string;
  tabIndex: number;
  tag: 'div' | 'span';
};

type HoverableState = {
  isHovered: boolean;
};

/**
 * Injects `isHovered` into child function component when user hovers
 */
class Hoverable extends React.Component<HoverableProps, HoverableState> {
  static defaultProps = {
    tabIndex: 0,
    tag: 'div',
  };

  state = {
    isHovered: false,
  };

  hover = (isHovered: boolean) => () => {
    this.setState({ isHovered });
  };

  render() {
    const {
      children,
      className,
      describedById,
      tabIndex,
      tag: Tag,
    } = this.props;

    return (
      <Tag
        aria-describedby={this.state.isHovered ? describedById : undefined}
        className={className}
        css={{ outline: 'none' }}
        onBlur={this.hover(false)}
        onFocus={this.hover(true)}
        onMouseEnter={this.hover(true)}
        onMouseLeave={this.hover(false)}
        tabIndex={tabIndex}
      >
        {children(this.state)}
      </Tag>
    );
  }
}

export default Hoverable;
